import React, { useState, useEffect, useCallback, Fragment } from "react";
import { useParams } from "react-router-dom";
import Axios from "axios";
import { useAPI, Grid, Card } from "components/lib";
import { applyFormTheme, useFormBrandColor } from "components/survey/formTheme";
import { StylesManager, Model } from "survey-core";
import { Survey } from "survey-react-ui";
import { validatePoaUpload } from "./poa-upload-check";
import { uploadFailureMessage } from "./upload-error";
import { attachScoring } from "./scoringRunner";
import { ScoringSummary } from "./scoringSummary";
import "survey-core/defaultV2.min.css";
const Settings = require("settings.json");
const server_url = Settings[process.env.NODE_ENV].server_url;

StylesManager.applyTheme("defaultV2");

export function ResponseView(props) {
  // console.log("settings", Settings);
  const [response, setResponse] = useState({});
  const [formData, setFormData] = useState(null);
  const [ready, setReady] = useState(false);

  const params = useParams();
  const responseAPI = useAPI(`/api/public/response/${params.id}`);

  const uploadFiles = useCallback(async (sender, options) => {
    console.log("uploadFiles", sender, options);

    const poaCheck = await validatePoaUpload({
      files: options.files,
      fieldName: options.name,
      formSchema: response.form_data,
      responseId: params.id,
      serverUrl: server_url,
    });

    if (!poaCheck.valid) {
      options.callback("error", poaCheck.message);
      return;
    }

    var formData = new FormData();
    options.files.forEach(function (file) {
      formData.append("file", file);
      formData.append("response_id", params.id);
      formData.append("field_name", options.name);
      formData.append("file_name", file.name);
    });

    Axios.post(server_url + "/api/utility/gcp/upload", formData).then((data) => {
      console.log("data", data);
      options.callback(
        "success",
        options.files.map(function (file) {
          return {
            file: file,
            name: data.data.name,
            type: data.data.name,
            content: data.data.url,
            id: file.id,
          };
        })
      );
    }).catch((err) => {
      options.callback("error", uploadFailureMessage(err));
    });
  });


  useEffect(() => {
    (async () => {
      if (!responseAPI.loading && responseAPI.data !== null) {
        setResponse(responseAPI.data);
      }
    })();
  }, [responseAPI]);

  // form_data is a send-time snapshot; the theme is resolved live alongside it,
  // so a restyle reaches links already sent.
  useFormBrandColor(response.theme);

  useEffect(() => {
    setFormData(
      applyFormTheme(new Model(response.form_data), response.theme)
    );
    setReady(true);
  }, [response]);

  useEffect(() => {
    if (!formData) return undefined;
    // live score preview for scoring-enabled forms (server result is authoritative)
    return attachScoring(formData, response.form_data);
  }, [formData, response.form_data]);

  useEffect(() => {
    if (formData) {
      formData.onComplete.add(reponseComplete);
      formData.onUploadFiles.add(uploadFiles);
      // formData.onDownloadFile.add(async (sender, options) => {
      //   console.log("onDownloadFile", sender, options);
      //   const fileResponse = await Axios.get(
      //     server_url + "/api/utility/gcp/download?content=" + options.content
      //   );
      //   // return signed url or encrypted with key

      //   // get blob

      //   const fileBlob = fileResponse.data.blob;

      //   const byteCharacters = atob(fileBlob);
      //   const byteNumbers = new Array(byteCharacters.length);

      //   for (let i = 0; i < byteCharacters.length; i++) {
      //     byteNumbers[i] = byteCharacters.charCodeAt(i);
      //   }

      //   const byteArray = new Uint8Array(byteNumbers);
      //   const blob = new Blob([byteArray], {
      //     type: "application/octet-stream",
      //   });

      //   // Use FileReader to read the blob and create a preview
      //   const reader = new FileReader();

      //   reader.onload = function (e) {
      //     options.callback("success", e.target.result);
      //   };

      //   // Read the blob as data URL
      //   reader.readAsDataURL(blob);
      // });
    }
  }, [formData]);

  async function saveSurveyResults(url, json) {
    console.log("saveSurveyResults", url, json);
    await Axios.post(url, json);
  }

  const reponseComplete = useCallback((sender, options) => {
    console.log("reponseComplete", sender);
    console.log("data", sender.data);
    const resultData = [];
    for (const key in sender.data) {
      const question = sender.getQuestionByName(key);
      if (!!question) {
        const item = {
          name: key,
        };

        // Generate an array of file item values from a File question
        // ToDo: handle case where 2 files of the same name are uploaded for the same question (rare case)
        if (question.getType() === "file") {
          item.value = [];
          question.value.forEach((fileItem) => {
            item.value.push({
              ...fileItem,
              key: `${params.id}/${key}/${fileItem.name}`,
            });
          });
        } else {
          // For regular questions, simply use a value
          item.value = question.value;
        }
        resultData.push(item);
      }
    }
    console.log("resultData", resultData);
    const outputObject = {};

    resultData.forEach((item) => {
      outputObject[item.name] = item.value;
    });
    // Send data to a server storage
    saveSurveyResults("/api/public/response/" + params.id, outputObject);
  });

  // const uploadFiles = useCallback((sender, options) => {
  //   console.log("uploadFiles", sender, options);
  //   var formData = new FormData();
  //   options.files.forEach(function (file) {
  //     formData.append("file", file);
  //     formData.append("response_id", params.id);
  //     formData.append("field_name", options.name);
  //     formData.append("file_name", file.name);
  //   });
  //   var xhr = new XMLHttpRequest();
  //   xhr.open("POST", server_url + "/api/utility/gcp/upload");
  //   xhr.onload = function () {
  //     var data = JSON.parse(xhr.responseText);
  //     console.log("data", data);
  //     options.callback(
  //       "success",
  //       options.files.map(function (file) {
  //         return {
  //           file: file,
  //           name: data.name,
  //           type: data.name,
  //           content: data.url,
  //           id: file.id,
  //         };
  //       })
  //     );
  //   };
  //   console.log("form data", formData);
  //   xhr.send(formData);
  // });

  if (!formData) {
    return <div>Loading...</div>;
  }

  console.log("formData", formData);

  if (response && response.active === false) {
    return (
      <>
        <div className="min-w-min w-3/4">
          <Grid>
            <Card>
              <h2>Response Closed</h2>
              <div>
                This response is closed. You can no longer submit a response.
              </div>
              {response.scoring && (
                <div className="pt-4">
                  <ScoringSummary
                    scoring={response.scoring}
                    rating={response.rating}
                  />
                </div>
              )}
            </Card>
          </Grid>
        </div>
      </>
    );
  }

  if (ready) {
    return (
      <>
        <div className="min-w-min w-3/4">
          <Grid>
            <Card>
              <Survey model={formData} />
            </Card>
          </Grid>
        </div>
      </>
    );
  }
}
